
import { Box, Container, Typography, Grid, 
  FormControlLabel, Checkbox, Button, TextField, Select, MenuItem, FormControl, InputLabel, Drawer } from '@mui/material';

import {useState, useEffect} from 'react';

import {useAuth} from "../../contexts/AuthContext"

import {handlerOfCheckboxBy} from "../Utils"

import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { useHistory } from 'react-router-dom';

const db = app.firestore();

function handlerBy(setX) {
  return (event) => setX(event.target.value);
}

const SimpleSelect = ({value, onChange, label, options}) => {
  return (
    <FormControl fullWidth>
      <InputLabel id={label+"-id"}>{label}</InputLabel>              
      <Select
        value={value}
        onChange={onChange}
        labelId={label+"-id"}
        label={label}
      >
        {options.map(
          (option) => (<MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)
        )}
      </Select>
    </FormControl>
  );
}

export default function ItemCard({isUpdate, itemId, setLastRefreshDate, drawerState, drawerTitle, toggleDrawer, ...rest}) {
  const history = useHistory()

  const [name, setName] = useState("");
  const [sku, setSku] = useState("");
  const [weight, setWeight] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [lowThreshold, setLowThreshold] = useState(0);
  const [smsNotif, setSmsNotif] = useState(false);

  const {retailerId, currentUser} = useAuth();

  const resetForm = () => {
    setName("");
    setSku("");
    setWeight(0);
    setQuantity("");
    setLowThreshold("");
    setSmsNotif(false);
  }

  useEffect( () => {
    const loadAndSetItem = async () => {
      if(!itemId) {
        resetForm();
        return;
      }

      const itemRef = await db.collection('items').doc(itemId).get();
      const item = itemRef.data();
      
      setName(item.name??"");
      setSku(item.sku??"");
      setWeight(item.weight??0);
      setLowThreshold(item.lowThreshold??0);
      if(isUpdate) {
        setQuantity(item.quantity??0);
      }
      setSmsNotif(item.smsNotification??false);
    }

    loadAndSetItem();
  }, [itemId])

  // parts of this function and rest api should be transformed into a single trigger onCartUpdate to paid
  const handleConfirm = async () => {
    console.log("Add item started");

    try {
      const retailer = await db.collection('retailers').doc(retailerId).get();
      if (!retailer.exists) {
          throw new Error('retailer does not exists');
      }
      const retailerData = retailer.data();

      const newItem = {
        name,
        sku,
        weight,
        quantity,
        lowThreshold,
        smsNotification : smsNotif
      }

      if(isUpdate) {
        newItem.updatedBy = currentUser.email;
        await db.collection('items').doc(itemId).update(newItem); 
        console.log("ITEM UPDATED !!!!!!!!!!!!!");
        console.log(newItem);
      } else {
        newItem.creationDate = new Date();
        newItem.retailerId = retailerId; 
        
        newItem.createdBy = currentUser.email;
        newItem.updatedBy = currentUser.email;
        await db.collection('items').add(newItem); 
        console.log("ITEM ADDED !!!!!!!!!!!!!");
        console.log(newItem);
      }
      
      // const {message, hasError} = data.error ? {message: data.error, hasError: true} :
      //   {message: "La configuration a été mise à jour", hasError: false};

      // this.setState({
      //   toastMessage: "La configuration a été mise à jour",
      //   toastHasError: false,
      //   toastIsActive: true
      // });

      // history.push("/items");
      toggleDrawer(false, "", null, false)();

    } catch(e) {
      console.log("item submitted exception was thrown");
      console.log(e.message);
      // this.setState({
      //   toastMessage: errorMessage,
      //   toastHasError: true,
      //   toastIsActive: true
      // });
    }    
  }

  return (
    <Drawer
      anchor="right"
      open={drawerState}
      onClose={toggleDrawer(false, "", null, false)}
      >
      <Container maxWidth="sm" sx={{ m: 3}}>
        <Typography
            sx={{ mb: 3 }}
            variant="h4"
        >
              {drawerTitle}
        </Typography> 
        <form>
          {/* <Card>
            <CardContent> */}
              <Grid container spacing={4} wrap="wrap">
                <Grid item sm={12} xs={12} >
                  <Typography color="textPrimary" variant="h6">
                    Définition
                  </Typography>
                </Grid>                            
                <Grid item sm={12} xs={12} >
                  <TextField
                    value={sku}
                    onChange={handlerBy(setSku)}
                    label="SKU" 
                    disabled={quantity!=0}
                    required
                    type="text"
                    variant="outlined" 
                    fullWidth
                  />
                </Grid>
                <Grid item sm={12} xs={12} >
                  <TextField
                    value={name}
                    onChange={handlerBy(setName)}
                    label="Nom" 
                    required
                    type="text"
                    variant="outlined" 
                    fullWidth
                  />
                </Grid>
                <Grid item sm={12} xs={12} >
                  <TextField
                    value={weight}
                    onChange={handlerBy(setWeight)}
                    label="Poids (en g)" 
                    disabled={quantity!=0}
                    required
                    type="number"
                    variant="outlined" 
                    fullWidth
                  />
                </Grid>
                {/* <Grid item sm={6} xs={12} >
                  <TextField
                    value={quantity}
                    onChange={handlerBy(setQuantity)}
                    label="Quantité" 
                    type="number"
                    variant="outlined" 
                    disabled={quantity!=0}
                    fullWidth
                  />
                </Grid> */}
                <Grid item sm={12} xs={12} >
                  <Typography color="textPrimary" variant="h6">
                    Suivi
                  </Typography>
                </Grid> 
                <Grid item sm={12} xs={12} >
                  <TextField
                    value={lowThreshold}
                    onChange={handlerBy(setLowThreshold)}
                    label="Seuil bas" 
                    required
                    type="number"
                    variant="outlined" 
                    fullWidth
                  />
                </Grid>
                <Grid item sm={12} xs={12} >
                  <FormControlLabel label="Notification SMS" control={<Checkbox 
                    checked={smsNotif}
                    onChange={handlerOfCheckboxBy(setSmsNotif)}
                  />} />
                </Grid>
              {/* </Grid> */}
            {/* </CardContent>
            <Divider /> */}
              <Grid item sm={12} xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', pl: 3 }}>
                  <Button color="primary" variant="outlined" onClick={toggleDrawer(false, "", null, false)}>
                    Annuler
                  </Button>
                  <Box pr={2}>
                  </Box>
                  <Button color="primary" variant="contained" onClick={handleConfirm}>
                    Confirmer
                  </Button>
                </Box>
              </Grid>
            </Grid>
          {/* </Card> */}
        </form>
      </Container>
    </Drawer>
  );
}